// contributors-c
//
// Purpose: Community contributor preset categories (C)
//
// This module:
// - Exports preset categories: 3001ideaz through Jacobar475

import { toNameMap } from "../../../synth/synth-config";
import type { InputPresetCategory } from "./types";

export const contributorCategoriesC: InputPresetCategory[] = [
	{
		name: "3001ideaz's Presets",
		presets: toNameMap([
			// -------------JukeBox 0.2.1 presets--------------
			{
				name: "Fakebit Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "3001ideaz", "retro", "picked"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1 }],
					effects: ["reverb"],
					panDelay: 0,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3 2←4",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 1,
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "pulse width", pulseWidth: 8 },
						{ frequency: "0.12×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 0, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 0, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "operatorAmplitude", envelope: "wibble 2", index: 3 }],
				},
			},
			{
				name: "Deep Kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "3001ideaz", "kick"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["pitch shift"],
					pitchShiftSemitones: 5,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorFrequency", envelope: "twang 1", index: 0 },
						{
							target: "noteVolume",
							envelope: "twang 2",
						},
					],
				},
			},
			{
				name: "Melodic Knock",
				generalMidi: false,
				tags: ["pickedstring", "3001ideaz", "picked", "novelty"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 1.4142 },
					],
					effects: ["echo", "reverb"],
					panDelay: 0,
					echoSustain: 100,
					echoDelayBeats: 0.75,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						71, 57, 86, 71, 71, 86, 86, 86, 86, 100, 71, 57, 71, 71, 57, 57, 71, 57, 43,
						29, 29, 14, 14, 14, 14, 29, 29, 29,
					],
					unison: "hecking gosh",
					stringSustain: 0,
					envelopes: [],
				},
			},
			// -------------JukeBox 0.2.3--------------
			{
				name: "Chip Oboe",
				generalMidi: false,
				tags: ["chip", "customchip", "3001ideaz", "retro", "flute", "picked"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 840.9, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 840.9, linearGain: 1.4142 }],
					effects: ["vibrato", "note filter", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.7071 }],
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "sandbox r-sawtooth",
					unison: "none",
					customChipWave: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 24,
						"14": 24,
						"15": 24,
						"16": 24,
						"17": 24,
						"18": 24,
						"19": 24,
						"20": 24,
						"21": 24,
						"22": 24,
						"23": 24,
						"24": 24,
						"25": 24,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Cul",
				generalMidi: false,
				tags: ["fm", "fm4op", "3001ideaz", "retro", "distortion"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.125 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.125 },
					],
					effects: ["note filter", "distortion", "bitcrusher"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.1768 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 1,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.1768 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 1,
						},
					],
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 43,
					panDelay: 0,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 24,
					algorithm: "1←2←3←4",
					feedbackType: "2→3",
					feedbackAmplitude: 14,
					operators: [
						{
							frequency: "0.75×",
							amplitude: 12,
							waveform: "pulse width",
							pulseWidth: 9,
						},
						{ frequency: "3×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "12×", amplitude: 9, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "distortion",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 0.07,
							perEnvelopeLowerBound: 1.3,
							perEnvelopeUpperBound: 1.9,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 0.6,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "operatorAmplitude",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 6.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 0.7,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Chip Sitar",
				generalMidi: false,
				tags: ["chip", "customchip", "3001ideaz", "picked", "pad"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 5.6569,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 5.6569,
						},
					],
					effects: ["transition type", "note filter", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 5.6569 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 5.6569 }],
					panDelay: 0,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -12,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 8,
						"1": -5,
						"2": 0,
						"3": 0,
						"4": -4,
						"5": -1,
						"6": -12,
						"7": -1,
						"8": 0,
						"9": 0,
						"10": -1,
						"11": 2,
						"12": -1,
						"13": 0,
						"14": 1,
						"15": -2,
						"16": -1,
						"17": -1,
						"18": -1,
						"19": -18,
						"20": -5,
						"21": 0,
						"22": -24,
						"23": 4,
						"24": 0,
						"25": 18,
						"26": 0,
						"27": -1,
						"28": 0,
						"29": -22,
						"30": -1,
						"31": -1,
						"32": -3,
						"33": -1,
						"34": 1,
						"35": -1,
						"36": 0,
						"37": -16,
						"38": 0,
						"39": 0,
						"40": -3,
						"41": -3,
						"42": -1,
						"43": 0,
						"44": -10,
						"45": -1,
						"46": 20,
						"47": 0,
						"48": 0,
						"49": -3,
						"50": -1,
						"51": -1,
						"52": 0,
						"53": 0,
						"54": -1,
						"55": -1,
						"56": 0,
						"57": 21,
						"58": -1,
						"59": -1,
						"60": 8,
						"61": -2,
						"62": 8,
						"63": 0,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 15,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "FM 6-Op Hi-Hat",
				generalMidi: false,
				tags: ["fm", "fm6op", "3001ideaz", "hihat", "retro"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					algorithm: "1←(2 3←5 4←6)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "100×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "100×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~20×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Better PWM Overdrive",
				generalMidi: false,
				tags: ["pwm", "3001ideaz", "distortion", "guitar", "retro"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 4,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 4,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
					],
					effects: ["vibrato", "note filter", "distortion", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 250,
							linearGain: 0.5,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.125 },
						{
							type: "high-pass",
							cutoffHz: 250,
							linearGain: 0.5,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					distortion: 100,
					aliases: false,
					panDelay: 0,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					pulseWidth: 49,
					decimalOffset: 0,
					unison: "fifth",
					envelopes: [
						{
							target: "distortion",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 0.2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 2.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Rhythmic Stutter Lead",
				generalMidi: false,
				tags: ["fm", "fm6op", "3001ideaz", "pad", "bellows"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 0.5,
						},
					],
					effects: ["vibrato", "note filter", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 1.4142 }],
					panDelay: 10,
					reverb: 6,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -12,
					algorithm: "1←4(2←5 3←6",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 1,
					operators: [
						{ frequency: "0.25×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{
							frequency: "0.5×",
							amplitude: 14,
							waveform: "pulse width",
							pulseWidth: 8,
						},
						{ frequency: "0.12×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 7, waveform: "pulse width", pulseWidth: 6 },
						{ frequency: "4×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 0.09,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.05,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
							waveform: 0,
							steps: 2,
						},
						{
							target: "feedbackAmplitude",
							envelope: "flare",
							inverse: true,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Electric FM",
				generalMidi: false,
				tags: ["fm", "fm4op", "3001ideaz", "picked", "guitar", "retro"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 4,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 4,
						},
					],
					effects: ["transition type", "note filter", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -12,
					algorithm: "(1 2 3)←4",
					feedbackType: "2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "4×", amplitude: 12, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{
							frequency: "0.5×",
							amplitude: 15,
							waveform: "pulse width",
							pulseWidth: 5,
						},
						{ frequency: "0.75×", amplitude: 3, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 0.7,
							perEnvelopeLowerBound: 1.4,
							perEnvelopeUpperBound: 1.7,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 0.02,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "FM Overdriven Guitar",
				generalMidi: false,
				tags: ["fm", "fm4op", "3001ideaz", "retro", "distortion", "guitar"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 2948.87, linearGain: 2 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 4,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["vibrato", "distortion", "bitcrusher", "reverb"],
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0.135,
					fadeOutTicks: 6,
					algorithm: "1←2←(3 4)",
					feedbackType: "ALL",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 4, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 4 },
						{ frequency: "0.75×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Talking Chip",
				generalMidi: false,
				tags: ["chip", "customchip", "3001ideaz", "retro", "vocal"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.7071 },
					],
					effects: ["note filter", "distortion"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 11.3137 }],
					distortion: 57,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 24,
						"7": 24,
						"8": 24,
						"9": 24,
						"10": 24,
						"11": 24,
						"12": 24,
						"13": 24,
						"14": 24,
						"15": 24,
						"16": 24,
						"17": 24,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 24,
						"24": 24,
						"25": 24,
						"26": 24,
						"27": 24,
						"28": 24,
						"29": 24,
						"30": 24,
						"31": 24,
						"32": 24,
						"33": 24,
						"34": 24,
						"35": 24,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 14,
							perEnvelopeLowerBound: 0.3,
							perEnvelopeUpperBound: 0.4,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Manual Strong Kick",
				generalMidi: false,
				tags: ["harmonics", "3001ideaz", "idiophone", "novelty"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.3536 }],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.3536 }],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					harmonics: [
						100, 43, 43, 29, 43, 43, 14, 14, 0, 14, 29, 0, 14, 14, 14, 0, 14, 14, 14, 0,
						14, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Bootleg Sax Synth",
				generalMidi: false,
				tags: ["fm", "fm6op", "3001ideaz", "retro", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.7071 },
					],
					effects: ["pitch shift", "detune", "distortion"],
					pitchShiftSemitones: 23,
					detuneCents: 92,
					distortion: 71,
					aliases: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "0.5×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 4, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Deep Harmonic Bass",
				generalMidi: false,
				tags: ["harmonics", "3001ideaz", "pad"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 0.25 }],
					effects: ["chord type", "chorus", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 0,
					chorus: 100,
					reverb: 48,
					fadeInSeconds: 0.0575,
					fadeOutTicks: 12,
					harmonics: [
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Bootleg PWM",
				generalMidi: false,
				tags: ["pwm", "3001ideaz", "retro", "distortion"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 1.4142,
						},
					],
					effects: ["note filter", "distortion", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 0.3536,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 0.3536,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					distortion: 86,
					aliases: false,
					panDelay: 10,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					pulseWidth: 47,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 8.5,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 0.7,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Chip of Moderate Emotion",
				generalMidi: false,
				tags: ["chip", "chipwave", "3001ideaz", "chiptune"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "high-pass", cutoffHz: 297.3, linearGain: 2.8284 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 297.3, linearGain: 2.8284 }],
					effects: ["vibrato", "note filter"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "modbox piccolo",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 7,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0.7,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Enraged Chip",
				generalMidi: false,
				tags: ["fm", "fm4op", "3001ideaz", "distortion", "retro"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "peak", cutoffHz: 2000, linearGain: 4 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 2000, linearGain: 4 }],
					effects: ["reverb"],
					panDelay: 10,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1↔2 3↔4",
					feedbackAmplitude: 1,
					operators: [
						{
							frequency: "0.5×",
							amplitude: 14,
							waveform: "pulse width",
							pulseWidth: 4,
						},
						{ frequency: "0.25×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 1, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.04,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
							waveform: 2,
							steps: 2,
						},
						{
							target: "feedbackAmplitude",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.7,
							perEnvelopeUpperBound: 0.8,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
					],
				},
			},
			// { name: "", generalMidi: false, tags:["", "3001ideaz"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "3001ideaz"], settings: {} },
		]),
	},
	{
		name: "ex1's Presets",
		presets: toNameMap([
			// -------------JukeBox 0.2.3 presets--------------
			{
				name: "Crunchy Crushed Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "ex1", "distortion", "picked", "guitar"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					eqSubFilters1: [],
					effects: ["transition type", "distortion", "bitcrusher", "chorus"],
					transition: "interrupt",
					clicklessTransition: false,
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 100,
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2←3←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "distortion",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Distant Voice Pad",
				generalMidi: false,
				tags: ["harmonics", "ex1", "featured", "bellows", "vocal"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 2 },
						{ type: "peak", cutoffHz: 250, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 4 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.125 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 2.8284 },
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 4 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 2 },
						{ type: "peak", cutoffHz: 250, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 4 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.125 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 2.8284 },
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 4 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 4 },
					],
					effects: ["vibrato", "granular", "distortion", "chorus", "reverb"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					granular: 4,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					distortion: 14,
					aliases: false,
					panDelay: 0,
					chorus: 100,
					reverb: 100,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 96,
					harmonics: [
						100, 100, 86, 57, 29, 29, 57, 71, 57, 29, 14, 14, 14, 29, 43, 57, 43, 29,
						14, 29, 57, 71, 86, 57, 29, 0, 0, 0,
					],
					unison: "octave",
					envelopes: [],
				},
			},
			{
				name: "Bubbly Blip",
				generalMidi: false,
				tags: ["chip", "chipwave", "ex1", "retro", "pad"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.5 }],
					effects: [
						"chord type",
						"pitch shift",
						"note filter",
						"granular",
						"chorus",
						"echo",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					pitchShiftSemitones: 24,
					noteFilterType: true,
					noteSimpleCut: 6,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 2500, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2500, linearGain: 0.5 }],
					granular: 3,
					grainSize: 49,
					grainAmounts: 5,
					grainRange: 40,
					panDelay: 0,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 77,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "square",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 15,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Shining Pad",
				generalMidi: false,
				tags: ["fm", "fm4op", "ex1", "bellows"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.7071 }],
					effects: ["note filter", "chorus", "reverb"],
					noteFilterType: true,
					noteSimpleCut: 5,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 }],
					panDelay: 10,
					chorus: 100,
					reverb: 0,
					fadeInSeconds: 0.0575,
					fadeOutTicks: 96,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "4⟲",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "4×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Deep Ambience Keys",
				generalMidi: false,
				tags: ["harmonics", "ex1", "pad", "bellows"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 2.8284,
						},
						{ type: "low-pass", cutoffHz: 707.11, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 2.8284,
						},
						{ type: "low-pass", cutoffHz: 707.11, linearGain: 0.3536 },
					],
					effects: ["note filter", "granular", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.125 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.125 }],
					granular: 6,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					panDelay: 0,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 100, 100, 100, 100, 71, 71, 71, 57, 57, 57, 57, 57, 57, 57, 57,
						57, 57, 57, 71, 71, 71, 71, 43, 29, 29, 14,
					],
					unison: "shimmer",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Oceanic Sparkles",
				generalMidi: false,
				tags: ["pickedstring", "ex1", "picked", "bellows", "pad"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.3536,
						},
					],
					effects: ["granular", "echo", "reverb"],
					granular: 4,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						43, 86, 29, 71, 57, 0, 0, 86, 100, 100, 86, 57, 0, 0, 86, 29, 43, 43, 43,
						57, 57, 57, 43, 14, 14, 43, 14, 14,
					],
					unison: "shimmer",
					stringSustain: 86,
					envelopes: [],
				},
			},
			{
				name: "Light Crush Pulse",
				generalMidi: false,
				tags: ["chip", "customchip", "ex1", "distortion", "retro"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "peak", cutoffHz: 2378.41, linearGain: 1.4142 },
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 2378.41, linearGain: 1.4142 },
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 1.4142 },
					],
					eqSubFilters1: [],
					effects: ["vibrato", "distortion", "bitcrusher"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 0,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "square",
					unison: "octave",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": -24,
						"7": -24,
						"8": 24,
						"9": 24,
						"10": 24,
						"11": 12,
						"12": 13,
						"13": 16,
						"14": 17,
						"15": 19,
						"16": 20,
						"17": 22,
						"18": 23,
						"19": 24,
						"20": 24,
						"21": 24,
						"22": 24,
						"23": 24,
						"24": 24,
						"25": 24,
						"26": 24,
						"27": 24,
						"28": 24,
						"29": 24,
						"30": 24,
						"31": 24,
						"32": 24,
						"33": 24,
						"34": 24,
						"35": 24,
						"36": 24,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": -16,
						"49": -17,
						"50": -18,
						"51": -19,
						"52": -20,
						"53": -21,
						"54": -21,
						"55": -22,
						"56": -23,
						"57": -23,
						"58": -24,
						"59": -24,
						"60": -24,
						"61": -24,
						"62": -24,
						"63": -24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "bitcrusherFrequency",
							envelope: "lfo",
							inverse: true,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 0.7,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "lfo",
							inverse: true,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 0.7,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 2,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Grainy Pulse",
				generalMidi: false,
				tags: ["pwm", "ex1", "novelty", "distortion"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "peak", cutoffHz: 250, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 500, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 250, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 500, linearGain: 0.7071 },
					],
					effects: ["transition type", "granular", "bitcrusher"],
					transition: "interrupt",
					clicklessTransition: false,
					granular: 3,
					grainSize: 49,
					grainAmounts: 3,
					grainRange: 40,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					pulseWidth: 16,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "twang",
							inverse: true,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Blippy Pulse",
				generalMidi: false,
				tags: ["pwm", "ex1", "retro", "picked"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					effects: ["pitch shift", "chorus"],
					pitchShiftSemitones: 24,
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					pulseWidth: 15,
					decimalOffset: 0,
					unison: "hum",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: true,
						},
					],
				},
			},
			{
				name: "Crystal Sparkles",
				generalMidi: false,
				tags: ["fm", "fm4op", "ex1", "featured", "idiophone", "pad"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 2000,
							linearGain: 2,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 2000,
							linearGain: 2,
						},
					],
					eqSubFilters1: [],
					effects: ["pitch shift", "vibrato", "granular", "echo", "reverb"],
					pitchShiftSemitones: 0,
					vibrato: "custom",
					vibratoDepth: 2,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					granular: 4,
					grainSize: 49,
					grainAmounts: 3,
					grainRange: 40,
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 0.583,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "vibratoDepth",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: true,
						},
					],
				},
			},
			{
				name: "Muted Overdrive",
				generalMidi: false,
				tags: ["pickedstring", "ex1", "picked", "distortion"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.25 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.25 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.3536 },
					],
					effects: ["chord type", "note filter", "distortion", "bitcrusher", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 8000,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 8000,
							linearGain: 0.7071,
						},
					],
					distortion: 86,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 100,
					panDelay: 0,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					harmonics: [
						86, 29, 43, 57, 71, 71, 57, 57, 43, 43, 29, 29, 29, 29, 29, 29, 29, 57, 57,
						57, 57, 57, 57, 43, 43, 43, 43, 29,
					],
					unison: "resonance",
					stringSustain: 57,
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "distortion",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "stringSustain",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// { name: "", generalMidi: false, tags:["", "ex1"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "ex1"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "ex1"], settings: {} },
		]),
	},
	{
		name: "Ashiiware's Presets",
		presets: toNameMap([
			// -------------JukeBox 0.2.3 presets--------------
			{
				name: "Sol Pad",
				generalMidi: false,
				tags: ["pwm", "ashiiware", "pad"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 8,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 6,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 8,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.7071 },
					],
					effects: ["transition type", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					panDelay: 0,
					reverb: 65,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 25,
					decimalOffset: 0,
					unison: "chorus",
					envelopes: [
						{
							target: "unison",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.1,
							discrete: false,
							waveform: 5,
							steps: 8,
						},
					],
				},
			},
			{
				name: "Infipad",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "pad"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
					],
					effects: ["chorus", "echo", "reverb"],
					panDelay: 0,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 7,
					operators: [
						{ frequency: "2×", amplitude: 7, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 13, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 0, waveform: "trapezoid", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 20,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1.9,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 0.6667,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
					],
				},
			},
			{
				name: "Mercury Pulse",
				generalMidi: false,
				tags: ["pwm", "ashiiware", "retro"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["transition type", "bitcrusher", "echo"],
					transition: "normal",
					clicklessTransition: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "octave",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "unison",
							envelope: "blip",
							inverse: true,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 0,
							discrete: true,
						},
					],
				},
			},
			{
				name: "Infipulse",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware", "retro"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "pitch shift", "echo"],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 24,
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 1.5,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "1/4 pulse",
					unison: "dissonant",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 4,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "unison",
							envelope: "blip",
							inverse: true,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.6,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Depths Choir",
				generalMidi: false,
				tags: ["chip", "customchip", "ashiiware", "vocal"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["vibrato", "note filter", "granular", "echo", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					granular: 7,
					grainSize: 22,
					grainAmounts: 8,
					grainRange: 14,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 1.25,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -20,
						"1": -19,
						"2": -13,
						"3": -9,
						"4": -7,
						"5": -9,
						"6": -13,
						"7": -19,
						"8": -19,
						"9": -9,
						"10": 0,
						"11": 7,
						"12": 13,
						"13": 17,
						"14": 17,
						"15": 15,
						"16": 11,
						"17": 6,
						"18": -2,
						"19": -9,
						"20": -15,
						"21": -20,
						"22": -22,
						"23": -20,
						"24": -19,
						"25": -13,
						"26": -6,
						"27": 2,
						"28": 9,
						"29": 15,
						"30": 20,
						"31": 22,
						"32": 20,
						"33": 17,
						"34": 11,
						"35": 4,
						"36": -6,
						"37": -13,
						"38": -20,
						"39": -19,
						"40": -15,
						"41": -15,
						"42": -17,
						"43": -22,
						"44": -17,
						"45": -9,
						"46": -4,
						"47": 2,
						"48": 4,
						"49": 6,
						"50": 2,
						"51": -2,
						"52": -9,
						"53": -17,
						"54": -19,
						"55": -9,
						"56": -2,
						"57": 4,
						"58": 7,
						"59": 7,
						"60": 4,
						"61": 0,
						"62": -6,
						"63": -13,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "grainFreq",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 0.6667,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1.4,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Depths Bell",
				generalMidi: false,
				tags: ["harmonics", "ashiiware", "idiophone"],
				settings: {
					type: "harmonics",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["granular", "echo", "reverb"],
					granular: 3,
					grainSize: 40,
					grainAmounts: 8,
					grainRange: 21,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 1,
					reverb: 65,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						100, 0, 86, 0, 29, 0, 0, 0, 29, 0, 71, 29, 0, 86, 0, 0, 0, 14, 0, 0, 0, 0,
						0, 43, 0, 0, 0, 0,
					],
					unison: "shimmer",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Entropy Guitar",
				generalMidi: false,
				tags: ["supersaw", "ashiiware", "featured", "distortion"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "low-pass", cutoffHz: 3049.17, linearGain: 1.4142 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 3,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [
						"vibrato",
						"note filter",
						"granular",
						"distortion",
						"bitcrusher",
						"echo",
						"reverb",
					],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 4,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 4,
						},
					],
					granular: 1,
					grainSize: 30,
					grainAmounts: 8,
					grainRange: 15,
					distortion: 100,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 0,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 1,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					pulseWidth: 30,
					decimalOffset: 0,
					dynamism: 83,
					spread: 17,
					shape: 0,
					envelopes: [
						{
							target: "distortion",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 1.5,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Echo Wave",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware", "chiptune", "picked"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["pitch shift", "echo", "reverb"],
					pitchShiftSemitones: 24,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 1.5,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "rounded",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 64,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Flow Lead",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware", "featured", "retro"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["granular", "chorus", "echo", "reverb"],
					granular: 2,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					panDelay: 0,
					chorus: 43,
					echoSustain: 57,
					echoDelayBeats: 1,
					reverb: 45,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "1/4 pulse",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 4,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Flow Pulse",
				generalMidi: false,
				tags: ["chip", "customchip", "ashiiware", "retro"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chorus", "echo", "reverb", "ring mod"],
					ringMod: 29,
					ringModHz: 49,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					panDelay: 0,
					chorus: 57,
					echoSustain: 86,
					echoDelayBeats: 1.083,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": -24,
						"7": -24,
						"8": -24,
						"9": -24,
						"10": -24,
						"11": -24,
						"12": -24,
						"13": -24,
						"14": -24,
						"15": -24,
						"16": 24,
						"17": 24,
						"18": 24,
						"19": 24,
						"20": 24,
						"21": 24,
						"22": 24,
						"23": 24,
						"24": 24,
						"25": 24,
						"26": 24,
						"27": 24,
						"28": 24,
						"29": 24,
						"30": 24,
						"31": 24,
						"32": 24,
						"33": 24,
						"34": 24,
						"35": 24,
						"36": 24,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "ringModulationHz",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Flow Choir",
				generalMidi: false,
				tags: ["fm", "fm6op", "ashiiware", "featured", "vocal"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1189.21, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 5.6569 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1189.21, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 5.6569 },
					],
					effects: ["transition type", "note filter", "chorus", "echo", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 }],
					panDelay: 0,
					chorus: 86,
					echoSustain: 71,
					echoDelayBeats: 1.5,
					reverb: 42,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "(1 2 3 4 5)←6",
					feedbackType: "ALL",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 6, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Flow Whistle",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware", "flute"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["pitch shift", "echo"],
					pitchShiftSemitones: 11,
					panDelay: 0,
					echoSustain: 86,
					echoDelayBeats: 1.083,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -3,
					wave: "modbox flatline",
					unison: "detune",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 20,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// -------------JukeBox 0.2.4 presets--------------
			{
				name: "Muted Choir",
				generalMidi: false,
				tags: ["spectrum", "ashiiware", "vocal"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
					],
					eqSubFilters1: [],
					effects: ["pitch shift", "detune", "granular", "chorus"],
					pitchShiftSemitones: 14,
					detuneCents: 28,
					granular: 7,
					grainSize: 44,
					grainAmounts: 9,
					grainRange: 37,
					panDelay: 10,
					chorus: 71,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					spectrum: [
						43, 0, 0, 57, 0, 0, 14, 100, 29, 0, 0, 100, 29, 0, 100, 0, 57, 29, 86, 14,
						14, 100, 14, 0, 14, 14, 0, 0, 43, 0,
					],
					unison: "voiced",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 0.7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Decayed Choir",
				generalMidi: false,
				tags: ["harmonics", "ashiiware", "vocal"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 2 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 5.6569 },
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 2 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 5.6569 },
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.25 },
					],
					effects: ["vibrato", "bitcrusher", "chorus", "reverb"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 100,
					reverb: 100,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 12,
					harmonics: [
						57, 71, 57, 43, 14, 14, 57, 71, 57, 14, 14, 14, 14, 14, 43, 57, 43, 14, 14,
						14, 14, 14, 14, 14, 0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Granular Pad",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware", "pad"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 2,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 2,
						},
					],
					effects: ["granular"],
					granular: 4,
					grainSize: 37,
					grainAmounts: 4,
					grainRange: 29,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "1/4 pulse",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 4,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Ambient Chip",
				generalMidi: false,
				tags: ["chip", "customchip", "ashiiware", "novelty"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 2.8284 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 2.8284 }],
					effects: ["vibrato", "note filter", "granular", "reverb"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 2.8284 }],
					granular: 7,
					grainSize: 49,
					grainAmounts: 2,
					grainRange: 21,
					panDelay: 0,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -12,
						"1": -12,
						"2": 0,
						"3": 0,
						"4": 12,
						"5": -24,
						"6": -24,
						"7": -12,
						"8": -12,
						"9": 0,
						"10": 12,
						"11": 12,
						"12": -24,
						"13": -12,
						"14": -12,
						"15": 0,
						"16": 0,
						"17": 12,
						"18": -24,
						"19": -24,
						"20": -12,
						"21": -12,
						"22": 0,
						"23": 12,
						"24": 12,
						"25": -24,
						"26": -12,
						"27": -12,
						"28": 0,
						"29": 0,
						"30": 12,
						"31": -24,
						"32": -24,
						"33": -12,
						"34": -12,
						"35": 0,
						"36": 12,
						"37": 12,
						"38": -24,
						"39": -12,
						"40": -12,
						"41": 0,
						"42": 0,
						"43": 12,
						"44": -24,
						"45": -24,
						"46": -12,
						"47": -12,
						"48": 0,
						"49": 12,
						"50": 12,
						"51": -24,
						"52": -12,
						"53": -12,
						"54": 0,
						"55": 0,
						"56": 12,
						"57": -24,
						"58": -24,
						"59": -12,
						"60": -12,
						"61": 0,
						"62": 12,
						"63": 12,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 0.3,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Ascension Guitar",
				generalMidi: false,
				tags: ["chip", "customchip", "ashiiware", "distortion", "picked"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["note filter", "distortion"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 707.11, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 2.8284,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 707.11, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 2.8284,
						},
					],
					distortion: 43,
					aliases: true,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "square",
					unison: "octave",
					customChipWave: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 24,
						"24": 24,
						"25": 24,
						"26": 24,
						"27": 24,
						"28": 24,
						"29": 24,
						"30": 24,
						"31": 24,
						"32": 24,
						"33": 24,
						"34": 24,
						"35": 24,
						"36": 24,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "distortion",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Muted Pulse",
				generalMidi: false,
				tags: ["pwm", "ashiiware", "retro"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
					],
					effects: ["note filter", "granular", "echo"],
					noteFilterType: true,
					noteSimpleCut: 8,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 4787.19, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4787.19, linearGain: 1 }],
					granular: 1,
					grainSize: 11,
					grainAmounts: 9,
					grainRange: 29,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 1.5,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 49,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "granular",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 2.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 1.25,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 0.6,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Saw Keys",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware", "novelty"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.0884,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.0884,
						},
					],
					effects: ["vibrato", "bitcrusher"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					bitcrusherOctave: 3,
					bitcrusherQuantization: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "zefbox sawtal",
					unison: "piano",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 16,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Distorted Vocalsynth",
				generalMidi: false,
				tags: ["fm", "fm6op", "ashiiware", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 250,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 840.9, linearGain: 5.6569 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 250,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 840.9, linearGain: 5.6569 },
					],
					effects: ["bitcrusher", "chorus", "echo", "reverb"],
					bitcrusherOctave: 6,
					bitcrusherQuantization: 57,
					panDelay: 10,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3 2←(4 5)←6",
					feedbackType: "2→3",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 11, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 2, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
					],
				},
			},
			{
				name: "Granusquare",
				generalMidi: false,
				tags: ["chip", "customchip", "ashiiware", "novelty"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 500, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 500, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.3536 },
					],
					effects: ["note filter", "granular", "bitcrusher", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 11.3137 }],
					granular: 2,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					bitcrusherOctave: 3,
					bitcrusherQuantization: 0,
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": -24,
						"7": -24,
						"8": -24,
						"9": -24,
						"10": -24,
						"11": -24,
						"12": -24,
						"13": -24,
						"14": -24,
						"15": -24,
						"16": -24,
						"17": -24,
						"18": -24,
						"19": -24,
						"20": -24,
						"21": -24,
						"22": -24,
						"23": -24,
						"24": -24,
						"25": -24,
						"26": -24,
						"27": -24,
						"28": -24,
						"29": -24,
						"30": -24,
						"31": -24,
						"32": 24,
						"33": 24,
						"34": 24,
						"35": 24,
						"36": 24,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 0.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Granular Pluck",
				generalMidi: false,
				tags: ["pickedstring", "ashiiware", "novelty"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "low-pass", cutoffHz: 9656.85, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 9,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["granular", "bitcrusher", "chorus", "echo"],
					granular: 1,
					grainSize: 3,
					grainAmounts: 2,
					grainRange: 25,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 86,
					panDelay: 0,
					chorus: 100,
					echoSustain: 57,
					echoDelayBeats: 1.667,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						0, 0, 0, 0, 0, 0, 0, 57, 0, 0, 0, 0, 0, 0, 100, 43, 0, 0, 14, 86, 0, 14, 0,
						0, 0, 0, 0, 86,
					],
					unison: "none",
					stringSustain: 14,
					envelopes: [],
				},
			},
			{
				name: "Midnight Whistle",
				generalMidi: false,
				tags: ["harmonics", "ashiiware"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 2110.37, linearGain: 1.4142 }],
					eqFilterType: true,
					eqSimpleCut: 6,
					eqSimplePeak: 3,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [
						"transition type",
						"vibrato",
						"note filter",
						"distortion",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.2,
					vibratoDelay: 19,
					vibratoSpeed: 5,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 4 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 4 },
					],
					distortion: 43,
					aliases: false,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 1.083,
					reverb: 87,
					fadeInSeconds: 0.0575,
					fadeOutTicks: -1,
					harmonics: [
						57, 0, 0, 0, 0, 0, 0, 0, 0, 86, 57, 0, 0, 0, 0, 0, 0, 0, 86, 0, 0, 0, 57,
						29, 0, 29, 100, 0,
					],
					unison: "octave",
					envelopes: [],
				},
			},
			{
				name: "Boombox Synth",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "chorus", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 500, linearGain: 8 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 500, linearGain: 8 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 16000, linearGain: 1 }],
					panDelay: 10,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 42,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1 2 3 4",
					feedbackType: "1→4 2→3",
					feedbackAmplitude: 14,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Crushed Bass Guitar",
				generalMidi: false,
				tags: ["harmonics", "ashiiware", "picked"],
				settings: {
					type: "harmonics",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "distortion", "bitcrusher", "reverb"],
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 3,
					bitcrusherQuantization: 0,
					panDelay: 0,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						100, 86, 71, 57, 71, 43, 57, 29, 29, 29, 29, 29, 29, 14, 14, 14, 14, 14, 14,
						14, 14, 14, 14, 14, 14, 14, 14, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Nightpluck",
				generalMidi: false,
				tags: ["pickedstring", "ashiiware", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.0884 }],
					effects: ["transition type", "bitcrusher", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					bitcrusherOctave: 3,
					bitcrusherQuantization: 0,
					panDelay: 0,
					echoSustain: 71,
					echoDelayBeats: 1,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					harmonics: [
						100, 86, 57, 0, 0, 57, 57, 57, 86, 57, 57, 43, 43, 43, 29, 29, 14, 14, 29,
						14, 14, 14, 29, 100, 57, 43, 14, 14,
					],
					unison: "none",
					stringSustain: 14,
					envelopes: [],
				},
			},
			{
				name: "Ceres Pad",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware", "pad"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.125,
						},
						{ type: "peak", cutoffHz: 11313.71, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.125,
						},
						{ type: "peak", cutoffHz: 11313.71, linearGain: 2 },
					],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 1 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "todbox beta banana wave",
					unison: "hum",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 35,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 3,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Ceres Bass",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware", "retro"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["chord type", "note filter", "bitcrusher", "chorus", "reverb"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.0884 }],
					bitcrusherOctave: 2,
					bitcrusherQuantization: 0,
					panDelay: 0,
					chorus: 57,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "rounded",
					unison: "spinner",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 64,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "lfo",
							inverse: true,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 2,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Neptune Pluck",
				generalMidi: false,
				tags: ["pickedstring", "ashiiware", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 1.4142 },
						{
							type: "low-pass",
							cutoffHz: 2000,
							linearGain: 0.0884,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 1.4142 },
						{
							type: "low-pass",
							cutoffHz: 2000,
							linearGain: 0.0884,
						},
					],
					eqSubFilters1: [],
					effects: ["note filter", "distortion", "chorus", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 1,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 1,
						},
					],
					distortion: 14,
					aliases: false,
					panDelay: 0,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1.5,
					reverb: 42,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						100, 57, 29, 14, 29, 29, 14, 14, 29, 29, 14, 14, 14, 0, 14, 0, 0, 14, 29, 0,
						14, 0, 0, 0, 14, 14, 14, 14,
					],
					unison: "none",
					stringSustain: 71,
					envelopes: [
						{
							target: "chorus",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Neptune Guitar",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "distortion"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 0.7071,
						},
					],
					effects: ["vibrato", "note filter", "distortion", "echo", "reverb"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 2 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 2 }],
					distortion: 100,
					aliases: false,
					panDelay: 0,
					echoSustain: 100,
					echoDelayBeats: 1.5,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.25×", amplitude: 5, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 14,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
							waveform: 3,
							steps: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 0.1,
							perEnvelopeLowerBound: 0.8,
							perEnvelopeUpperBound: 1.9,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Neptune Lead",
				generalMidi: false,
				tags: ["pwm", "ashiiware", "retro", "distortion"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 }],
					effects: ["transition type", "distortion", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					distortion: 71,
					aliases: false,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 2,
					reverb: 39,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 25,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.25,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 2,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Distortion Pad",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware", "distortion"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 6727.17,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 6727.17,
							linearGain: 0.7071,
						},
					],
					effects: ["vibrato", "note filter", "distortion", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.5,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.5,
						},
					],
					distortion: 86,
					aliases: false,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "1/4 pulse",
					unison: "shimmer",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 4,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Recursive Kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "kick"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["distortion", "bitcrusher"],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Ambisaw",
				generalMidi: false,
				tags: ["chip", "customchip", "ashiiware", "novelty"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 1189.21, linearGain: 0.0884 }],
					effects: ["note filter", "granular", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.0884 }],
					granular: 4,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					panDelay: 0,
					echoSustain: 71,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 21,
						"1": 21,
						"2": 21,
						"3": 18,
						"4": 18,
						"5": 16,
						"6": 16,
						"7": 12,
						"8": 12,
						"9": 10,
						"10": 10,
						"11": 7,
						"12": 7,
						"13": 4,
						"14": 4,
						"15": 2,
						"16": 2,
						"17": -1,
						"18": -1,
						"19": -4,
						"20": -4,
						"21": -7,
						"22": -7,
						"23": -9,
						"24": -9,
						"25": -13,
						"26": -13,
						"27": -15,
						"28": -15,
						"29": -15,
						"30": -17,
						"31": -17,
						"32": -20,
						"33": -20,
						"34": -23,
						"35": -23,
						"36": 22,
						"37": 22,
						"38": 20,
						"39": 20,
						"40": 17,
						"41": 17,
						"42": 14,
						"43": 14,
						"44": 12,
						"45": 12,
						"46": 8,
						"47": 8,
						"48": 6,
						"49": 6,
						"50": 4,
						"51": 4,
						"52": 0,
						"53": 0,
						"54": -2,
						"55": -2,
						"56": -5,
						"57": -5,
						"58": -5,
						"59": -8,
						"60": -8,
						"61": -11,
						"62": -11,
						"63": -13,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Trapezynth",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware", "distortion"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 0.1768,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 0.1768,
						},
					],
					effects: ["transition type", "note filter", "bitcrusher", "chorus", "echo"],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1189.21, linearGain: 5.6569 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1189.21, linearGain: 5.6569 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 100,
					panDelay: 0,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "trapezoid",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Crushed Choir",
				generalMidi: false,
				tags: ["spectrum", "ashiiware", "vocal"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 4,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 1.4142 },
					],
					eqSubFilters1: [],
					effects: ["vibrato", "note filter", "bitcrusher", "chorus", "reverb"],
					vibrato: "custom",
					vibratoDepth: 0.12,
					vibratoDelay: 36,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.7071 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.7071 },
					],
					bitcrusherOctave: 3,
					bitcrusherQuantization: 43,
					panDelay: 0,
					chorus: 14,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						43, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 57, 0, 0, 57, 0, 43, 0, 43, 0, 0, 29, 0,
						29, 0, 14, 14, 14, 0, 0,
					],
					unison: "octave",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Ambient Hyperbrass",
				generalMidi: false,
				tags: ["supersaw", "ashiiware", "brass"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.125 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.125 }],
					effects: ["note filter", "chorus", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.1768 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.1768 }],
					panDelay: 0,
					chorus: 100,
					echoSustain: 86,
					echoDelayBeats: 2,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					pulseWidth: 25,
					decimalOffset: 0,
					dynamism: 100,
					spread: 50,
					shape: 100,
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 1.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.8,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "supersawShape",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Starlit Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "picked"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 }],
					eqFilterType: true,
					eqSimpleCut: 5,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["echo"],
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 2,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Recursive Organ",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "bellows"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.3536 }],
					eqSubFilters1: [],
					effects: ["granular", "chorus", "reverb"],
					granular: 4,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					panDelay: 0,
					chorus: 43,
					reverb: 48,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 6,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Lofi Brass",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "brass"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 3049.17, linearGain: 1.4142 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 3,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chorus"],
					panDelay: 0,
					chorus: 100,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 96,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "4⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "4×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Radio Pulse",
				generalMidi: false,
				tags: ["pwm", "ashiiware", "retro"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
					],
					effects: ["echo", "reverb"],
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 0.75,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					pulseWidth: 49,
					decimalOffset: 0,
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Earth Bass",
				generalMidi: false,
				tags: ["harmonics", "ashiiware"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 3049.17, linearGain: 1.4142 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 3,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chord type", "vibrato", "note filter", "chorus", "echo"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.25 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.25 }],
					panDelay: 0,
					chorus: 86,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0.1575,
					fadeOutTicks: -1,
					harmonics: [
						57, 57, 71, 100, 71, 86, 71, 100, 86, 71, 86, 57, 57, 57, 43, 43, 43, 29,
						29, 29, 14, 14, 14, 14, 14, 29, 14, 14,
					],
					unison: "spinner",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Stellar Pulse",
				generalMidi: false,
				tags: ["pwm", "ashiiware", "retro"],
				settings: {
					type: "PWM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "pitch shift", "bitcrusher", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 24,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 0.75,
					reverb: 16,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "blip",
							inverse: true,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 1,
							discrete: true,
						},
						{
							target: "pitchShift",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: true,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: true,
						},
					],
				},
			},
			{
				name: "Voltage Bass",
				generalMidi: false,
				tags: ["pwm", "ashiiware"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 1681.79,
							linearGain: 0.125,
						},
						{ type: "peak", cutoffHz: 840.9, linearGain: 5.6569 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 1681.79,
							linearGain: 0.125,
						},
						{ type: "peak", cutoffHz: 840.9, linearGain: 5.6569 },
					],
					effects: ["transition type", "note filter", "bitcrusher", "chorus"],
					transition: "slide",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 420.45, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 420.45, linearGain: 1.4142 }],
					bitcrusherOctave: 2.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 43,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					pulseWidth: 25,
					decimalOffset: 0,
					unison: "piano",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "VAM6 Pad",
				generalMidi: false,
				tags: ["supersaw", "ashiiware", "pad"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 }],
					effects: ["bitcrusher", "reverb"],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					reverb: 100,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 24,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 58,
					shape: 0,
					envelopes: [],
				},
			},
			{
				name: "Pulse Bell",
				generalMidi: false,
				tags: ["pwm", "ashiiware", "novelty"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 1.4142 },
					],
					effects: ["note filter", "echo", "ring mod"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					ringMod: 57,
					ringModHz: 89,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 0,
					ringModHzOffset: 50,
					panDelay: 0,
					echoSustain: 86,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 25,
					decimalOffset: 0,
					unison: "shimmer",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.25,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0.8,
							perEnvelopeUpperBound: 1.4,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 3.5,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Sol Synth",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "chorus", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 5.6569 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 5.6569 }],
					panDelay: 0,
					chorus: 100,
					echoSustain: 57,
					echoDelayBeats: 1.083,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 24,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 7,
					operators: [
						{ frequency: "8×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 0, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 0, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 13, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 0.8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Stellar Snare",
				generalMidi: false,
				tags: ["noise", "ashiiware", "snare"],
				settings: {
					type: "noise",
					eqFilter: [{ type: "high-pass", cutoffHz: 250, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 250, linearGain: 0.7071 }],
					eqSubFilters1: [],
					effects: ["note filter", "distortion"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 16000,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 16000,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
					],
					distortion: 14,
					aliases: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "static",
					unison: "none",
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 17,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 3,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Pluto Pad",
				generalMidi: false,
				tags: ["supersaw", "ashiiware", "featured", "pad"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "peak", cutoffHz: 420.45, linearGain: 2.8284 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 420.45, linearGain: 2.8284 }],
					effects: [
						"chord type",
						"vibrato",
						"note filter",
						"granular",
						"distortion",
						"bitcrusher",
						"echo",
						"reverb",
					],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 2.8284 }],
					granular: 3,
					grainSize: 50,
					grainAmounts: 10,
					grainRange: 40,
					distortion: 14,
					aliases: true,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					echoSustain: 71,
					echoDelayBeats: 2,
					reverb: 48,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					pulseWidth: 49,
					decimalOffset: 0,
					dynamism: 100,
					spread: 50,
					shape: 50,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 0.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 0.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 2.25,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Tranquil Synth",
				generalMidi: false,
				tags: ["chip", "customchip", "ashiiware"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 5.6569,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 5.6569,
						},
					],
					effects: ["chord type", "vibrato", "granular", "bitcrusher", "reverb"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					granular: 4,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 0,
					reverb: 100,
					fadeInSeconds: 0.0575,
					fadeOutTicks: 96,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -1,
						"1": -1,
						"2": -4,
						"3": -4,
						"4": -8,
						"5": -8,
						"6": -11,
						"7": -11,
						"8": -14,
						"9": -14,
						"10": -17,
						"11": -17,
						"12": -20,
						"13": -20,
						"14": -24,
						"15": -24,
						"16": -23,
						"17": -23,
						"18": -20,
						"19": -20,
						"20": -17,
						"21": -17,
						"22": -14,
						"23": -14,
						"24": -11,
						"25": -11,
						"26": -7,
						"27": -7,
						"28": -4,
						"29": -4,
						"30": -1,
						"31": -1,
						"32": 2,
						"33": 2,
						"34": 5,
						"35": 5,
						"36": 8,
						"37": 8,
						"38": 12,
						"39": 12,
						"40": 15,
						"41": 15,
						"42": 18,
						"43": 18,
						"44": 21,
						"45": 21,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 21,
						"51": 21,
						"52": 18,
						"53": 18,
						"54": 15,
						"55": 15,
						"56": 12,
						"57": 12,
						"58": 8,
						"59": 8,
						"60": 5,
						"61": 5,
						"62": 2,
						"63": 2,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteVolume",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Saturn Pluck",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "picked"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "echo"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 4 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 4 }],
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1←(2 (3 (4",
					feedbackType: "1↔4 2↔3",
					feedbackAmplitude: 11,
					operators: [
						{ frequency: "2×", amplitude: 9, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 2, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 18,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 0.6,
							discrete: false,
							steps: 4,
							seed: 29,
							waveform: 0,
						},
						{
							target: "feedbackAmplitude",
							envelope: "flare",
							inverse: true,
							perEnvelopeSpeed: 9.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "lfo",
							inverse: true,
							perEnvelopeSpeed: 0.2,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Sunset Glitch",
				generalMidi: false,
				tags: ["fm", "fm6op", "ashiiware", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 500,
							linearGain: 0.125,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 500,
							linearGain: 0.125,
						},
					],
					effects: ["bitcrusher", "echo", "reverb"],
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 1.5,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3←5 4←6",
					feedbackType: "1→3",
					feedbackAmplitude: 12,
					operators: [
						{ frequency: "2×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 13, waveform: "quasi-sine", pulseWidth: 5 },
						{
							frequency: "0.5×",
							amplitude: 13,
							waveform: "pulse width",
							pulseWidth: 6,
						},
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 7 },
						{ frequency: "0.75×", amplitude: 0, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 9, waveform: "triangle", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "reverb",
							envelope: "lfo",
							inverse: true,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0.7,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
							waveform: 2,
							steps: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 2.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 20,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
						{
							target: "feedbackAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 0.6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Venus Pulse",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware", "retro"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "chorus", "echo"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 0,
					chorus: 100,
					echoSustain: 57,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "1/4 pulse",
					unison: "dissonant",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 4,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "chorus",
							envelope: "lfo",
							inverse: true,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 1,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Venus Bass",
				generalMidi: false,
				tags: ["supersaw", "ashiiware"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 2 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 2 }],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 1 }],
					panDelay: 0,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 58,
					shape: 0,
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "Sewersaw",
				generalMidi: false,
				tags: ["supersaw", "ashiiware"],
				settings: {
					type: "supersaw",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "chorus", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					panDelay: 10,
					chorus: 100,
					reverb: 58,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 50,
					shape: 0,
					envelopes: [],
				},
			},
			{
				name: "Sewer FM",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "chorus", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					panDelay: 10,
					chorus: 100,
					reverb: 42,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1←(2 3←4)",
					feedbackType: "2⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "4×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "11×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
					],
				},
			},
			{
				name: "Dyaow",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "chorus", "echo", "reverb"],
					noteFilterType: true,
					noteSimpleCut: 8,
					noteSimplePeak: 7,
					noteFilter: [{ type: "low-pass", cutoffHz: 4006.75, linearGain: 11.3137 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4006.75, linearGain: 11.3137 }],
					panDelay: 10,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1←3 2←4",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "~1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Bellish Flare",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 1000, linearGain: 2.8284 },
						{
							type: "low-pass",
							cutoffHz: 4756.83,
							linearGain: 4,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 1000, linearGain: 2.8284 },
						{
							type: "low-pass",
							cutoffHz: 4756.83,
							linearGain: 4,
						},
					],
					effects: ["note filter", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 250,
							linearGain: 1,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 250,
							linearGain: 1,
						},
					],
					panDelay: 10,
					chorus: 100,
					reverb: 84,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1←(2 3←4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Sewer Distortion",
				generalMidi: false,
				tags: ["pickedstring", "ashiiware", "distortion"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.5 },
					],
					effects: ["note filter", "distortion", "bitcrusher", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 500, linearGain: 2.8284 },
						{
							type: "low-pass",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 500, linearGain: 2.8284 },
						{
							type: "low-pass",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 100,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						86, 100, 100, 86, 86, 86, 86, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 57,
						57, 57, 57, 57, 57, 57, 57, 57, 57, 57,
					],
					unison: "none",
					stringSustain: 71,
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "Liquipulse",
				generalMidi: false,
				tags: ["pwm", "ashiiware"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 11.3137,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 11.3137,
						},
					],
					effects: ["vibrato", "chorus", "reverb"],
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					chorus: 100,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					pulseWidth: 26,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Sewer Choir",
				generalMidi: false,
				tags: ["spectrum", "ashiiware", "vocal"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "reverb"],
					noteFilterType: true,
					noteSimpleCut: 3,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 769.61, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 769.61, linearGain: 0.5 }],
					panDelay: 10,
					reverb: 90,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					spectrum: [
						43, 14, 14, 14, 14, 14, 14, 100, 14, 14, 14, 57, 14, 14, 100, 14, 43, 14,
						43, 14, 14, 43, 14, 29, 14, 29, 14, 14, 29, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Sewerpad",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "pad"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 2110.37, linearGain: 1.4142 }],
					eqFilterType: true,
					eqSimpleCut: 6,
					eqSimplePeak: 3,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chorus", "echo", "reverb"],
					panDelay: 10,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 52,
					fadeInSeconds: 0.0575,
					fadeOutTicks: 96,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 12,
					operators: [
						{ frequency: "3×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Cosmic FM",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 5.6569,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 5.6569,
						},
					],
					effects: ["chord type", "vibrato", "reverb"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					reverb: 100,
					fadeInSeconds: 0.0575,
					fadeOutTicks: 96,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Starry Square",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.0884 }],
					effects: ["transition type", "detune", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					detuneCents: 20,
					panDelay: 0,
					reverb: 45,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "detune",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Raspberry Choir",
				generalMidi: false,
				tags: ["harmonics", "ashiiware", "vocal"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 500, linearGain: 2 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 4 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 500, linearGain: 2 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 4 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.25 },
					],
					effects: ["vibrato", "distortion", "bitcrusher", "chorus", "reverb"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					chorus: 100,
					reverb: 68,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 48,
					harmonics: [
						71, 86, 100, 100, 86, 86, 57, 43, 29, 29, 29, 29, 29, 29, 43, 43, 43, 43,
						43, 29, 29, 29, 29, 14, 14, 14, 14, 14,
					],
					unison: "dirty",
					envelopes: [],
				},
			},
			{
				name: "Raspberry Kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "kick"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.0884 }],
					effects: ["distortion", "bitcrusher"],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Plural Bass",
				generalMidi: false,
				tags: ["chip", "customchip", "ashiiware"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.25 }],
					effects: ["chord type", "note filter", "chorus"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 2.8284 }],
					panDelay: 10,
					chorus: 57,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					wave: "square",
					unison: "octave",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": -24,
						"7": -24,
						"8": -24,
						"9": -24,
						"10": -24,
						"11": -24,
						"12": -24,
						"13": -24,
						"14": -24,
						"15": -24,
						"16": 24,
						"17": 24,
						"18": 24,
						"19": 24,
						"20": 24,
						"21": 24,
						"22": 24,
						"23": 24,
						"24": 24,
						"25": 24,
						"26": 24,
						"27": 24,
						"28": 24,
						"29": 24,
						"30": 24,
						"31": 24,
						"32": 24,
						"33": 24,
						"34": 24,
						"35": 24,
						"36": 24,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Plural Bells",
				generalMidi: false,
				tags: ["pickedstring", "ashiiware"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 9513.66, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 9513.66, linearGain: 2.8284 },
					],
					effects: ["granular", "bitcrusher", "echo"],
					granular: 3,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						86, 86, 0, 0, 0, 29, 14, 86, 0, 0, 29, 43, 0, 29, 71, 0, 0, 100, 0, 0, 29,
						43, 43, 43, 0, 100, 0, 29,
					],
					unison: "octave",
					stringSustain: 64,
					envelopes: [],
				},
			},
			{
				name: "Plural Guitar",
				generalMidi: false,
				tags: ["pwm", "ashiiware"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "peak", cutoffHz: 5656.85, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 5656.85, linearGain: 1.4142 }],
					effects: [
						"chord type",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					chord: "monophonic",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 0,
					vibrato: "custom",
					vibratoDepth: 0.68,
					vibratoDelay: 22,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1000, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1000, linearGain: 2.8284 }],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 71,
					panDelay: 0,
					chorus: 14,
					echoSustain: 71,
					echoDelayBeats: 1,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 0.3333,
							perEnvelopeLowerBound: 0.8,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "twang",
							inverse: true,
							perEnvelopeSpeed: 2.25,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Violet Pulse",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "vibrato", "granular", "distortion", "echo"],
					transition: "interrupt",
					clicklessTransition: false,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					granular: 2,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					distortion: 43,
					aliases: false,
					panDelay: 0,
					echoSustain: 14,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "1/8 pulse",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 8,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Violet Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "ashiiware"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.125 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.125 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.3536 },
					],
					effects: ["vibrato", "note filter", "bitcrusher", "chorus"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 8,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 6000, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 6000, linearGain: 0.5 }],
					bitcrusherOctave: 6,
					bitcrusherQuantization: 14,
					panDelay: 0,
					chorus: 86,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 (2 3)←5←6 4",
					feedbackType: "4⟲",
					feedbackAmplitude: 10,
					operators: [
						{ frequency: "0.12×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 10, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 14, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 0, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 1, waveform: "triangle", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 2.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
					],
				},
			},
			{
				name: "Decayed Music Box",
				generalMidi: false,
				tags: ["fm", "fm6op", "ashiiware"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 1414.21, linearGain: 1 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.1768 },
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.125 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 1414.21, linearGain: 1 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.1768 },
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.125 },
					],
					eqSubFilters1: [],
					effects: ["note filter", "distortion", "bitcrusher", "reverb"],
					noteFilterType: true,
					noteSimpleCut: 9,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 9656.85, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 9656.85, linearGain: 0.5 }],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 14,
					panDelay: 0,
					reverb: 39,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "Custom",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					customAlgorithm: { mods: [[3], [3], [4], [5], [6], []], carrierCount: 2 },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "50×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorFrequency",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
							steps: 32,
							seed: 2,
							waveform: 2,
						},
						{
							target: "noteVolume",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							steps: 32,
							seed: 2,
							waveform: 2,
						},
					],
				},
			},
			{
				name: "Surveillance Synth",
				generalMidi: false,
				tags: ["harmonics", "ashiiware"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 3049.17, linearGain: 1.4142 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 3,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["distortion", "bitcrusher", "chorus", "reverb"],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 3,
					bitcrusherQuantization: 14,
					panDelay: 10,
					chorus: 100,
					reverb: 90,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 96,
					harmonics: [
						100, 14, 57, 14, 29, 14, 14, 14, 0, 0, 0, 0, 14, 14, 14, 14, 14, 0, 0, 0, 0,
						0, 0, 0, 43, 43, 43, 43,
					],
					unison: "shimmer",
					envelopes: [],
				},
			},
			{
				name: "Riversine",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware", "featured"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 28,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.5 },
					],
					effects: ["note filter", "chorus", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.25 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.25 }],
					panDelay: 0,
					chorus: 86,
					echoSustain: 71,
					echoDelayBeats: 1,
					reverb: 16,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					wave: "modbox sine",
					unison: "recurve",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 92,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 1.6667,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "chorus",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0.9,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 2,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Crushed Wave",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["bitcrusher", "chorus", "echo", "reverb"],
					bitcrusherOctave: 3,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 100,
					echoSustain: 57,
					echoDelayBeats: 1.5,
					reverb: 55,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "rounded",
					unison: "octave",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 64,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Avocado Pulse",
				generalMidi: false,
				tags: ["chip", "customchip", "ashiiware"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 0.0884 }],
					eqSubFilters1: [],
					effects: [
						"transition type",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: true,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 }],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					chorus: 14,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "dirty",
					customChipWave: {
						"0": 22,
						"1": 15,
						"2": -1,
						"3": -5,
						"4": -8,
						"5": -10,
						"6": -12,
						"7": -13,
						"8": -14,
						"9": -16,
						"10": -17,
						"11": -18,
						"12": -18,
						"13": -19,
						"14": -19,
						"15": -19,
						"16": -20,
						"17": -20,
						"18": -20,
						"19": -20,
						"20": -20,
						"21": -20,
						"22": -19,
						"23": -18,
						"24": -18,
						"25": -19,
						"26": -19,
						"27": -20,
						"28": -21,
						"29": -21,
						"30": -22,
						"31": -23,
						"32": 11,
						"33": 7,
						"34": 3,
						"35": 0,
						"36": -2,
						"37": -3,
						"38": -4,
						"39": -6,
						"40": -7,
						"41": -7,
						"42": -8,
						"43": -8,
						"44": -8,
						"45": -8,
						"46": -8,
						"47": -7,
						"48": -6,
						"49": -3,
						"50": -1,
						"51": 3,
						"52": 8,
						"53": 9,
						"54": 11,
						"55": 11,
						"56": -17,
						"57": -17,
						"58": -19,
						"59": -21,
						"60": -21,
						"61": -22,
						"62": -23,
						"63": -24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Avocado Organ",
				generalMidi: false,
				tags: ["harmonics", "ashiiware"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 11313.71,
							linearGain: 11.3137,
						},
						{ type: "high-pass", cutoffHz: 125, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 11313.71,
							linearGain: 11.3137,
						},
						{ type: "high-pass", cutoffHz: 125, linearGain: 2.8284 },
					],
					eqSubFilters1: [],
					effects: ["transition type", "chorus", "reverb"],
					transition: "slide in pattern",
					clicklessTransition: false,
					panDelay: 0,
					chorus: 43,
					reverb: 45,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 48,
					harmonics: [
						86, 29, 71, 86, 29, 14, 57, 71, 57, 0, 29, 86, 0, 43, 29, 100, 29, 71, 29,
						57, 0, 0, 0, 29, 0, 0, 0, 57,
					],
					unison: "octave",
					envelopes: [],
				},
			},
			{
				name: "Avocado Kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "kick"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["distortion"],
					distortion: 14,
					aliases: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 1,
					operators: [
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Archives Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 707.11, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 707.11, linearGain: 0.5 }],
					effects: ["note filter", "distortion", "chorus"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 297.3, linearGain: 8 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 297.3, linearGain: 8 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 1000, linearGain: 1.4142 }],
					distortion: 14,
					aliases: false,
					panDelay: 10,
					chorus: 57,
					fadeInSeconds: 0.1575,
					fadeOutTicks: -3,
					algorithm: "(1 2 3)←4",
					feedbackType: "1→3",
					feedbackAmplitude: 9,
					operators: [
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Argovocals",
				generalMidi: false,
				tags: ["harmonics", "ashiiware", "vocal"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "peak", cutoffHz: 1000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 1000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 11.3137 },
					],
					effects: [
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 500, linearGain: 11.3137 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 5.6569 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 500, linearGain: 11.3137 },
					],
					distortion: 57,
					aliases: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 57,
					panDelay: 10,
					chorus: 43,
					echoSustain: 29,
					echoDelayBeats: 1,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						86, 100, 100, 100, 86, 86, 86, 29, 29, 29, 29, 43, 43, 43, 29, 29, 29, 29,
						29, 29, 29, 29, 29, 14, 14, 14, 14, 71,
					],
					unison: "fifth",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Holopad",
				generalMidi: false,
				tags: ["supersaw", "ashiiware", "pad"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "peak", cutoffHz: 2000, linearGain: 8 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 2000, linearGain: 8 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 0.7071,
						},
					],
					effects: ["vibrato", "note filter", "bitcrusher", "chorus"],
					vibrato: "custom",
					vibratoDepth: 0.24,
					vibratoDelay: 0,
					vibratoSpeed: 5,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.1768 }],
					bitcrusherOctave: 3,
					bitcrusherQuantization: 57,
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 25,
					decimalOffset: 0,
					dynamism: 100,
					spread: 33,
					shape: 50,
					envelopes: [],
				},
			},
			{
				name: "Ringsynth",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "featured"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.125 },
						{
							type: "low-pass",
							cutoffHz: 4756.83,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.125 },
						{
							type: "low-pass",
							cutoffHz: 4756.83,
							linearGain: 0.7071,
						},
					],
					effects: ["transition type", "detune", "vibrato", "granular", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					detuneCents: 12,
					vibrato: "custom",
					vibratoDepth: 0.32,
					vibratoDelay: 14,
					vibratoSpeed: 11,
					vibratoType: 0,
					granular: 2,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					panDelay: 10,
					reverb: 55,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "3⟲ 4⟲",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "3×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 4, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "detune",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Distorted Solo",
				generalMidi: false,
				tags: ["harmonics", "ashiiware", "vocal"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 8 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 8 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1.4142 },
					],
					effects: ["vibrato", "distortion", "bitcrusher", "chorus", "reverb"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 2.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 43,
					reverb: 48,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						71, 86, 100, 100, 86, 86, 71, 57, 43, 43, 43, 43, 29, 29, 29, 29, 29, 29,
						43, 29, 29, 43, 43, 43, 43, 43, 43, 14,
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Buzzsynth",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 11.3137 },
					],
					effects: ["bitcrusher", "echo"],
					bitcrusherOctave: 2.5,
					bitcrusherQuantization: 71,
					panDelay: 10,
					echoSustain: 57,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "wackybox buzz wave",
					unison: "octave",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 64,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Buzzsaw Pad",
				generalMidi: false,
				tags: ["supersaw", "ashiiware"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 1,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 1,
						},
					],
					effects: ["vibrato", "chorus", "echo"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					chorus: 100,
					echoSustain: 86,
					echoDelayBeats: 1.167,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					pulseWidth: 37,
					decimalOffset: 0,
					dynamism: 100,
					spread: 25,
					shape: 0,
					envelopes: [],
				},
			},
			{
				name: "Ruin Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["transition type"],
					transition: "slide",
					clicklessTransition: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "3⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 0, waveform: "pulse width", pulseWidth: 2 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 15,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Hatred Bass",
				generalMidi: false,
				tags: ["supersaw", "ashiiware", "featured"],
				settings: {
					type: "supersaw",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["vibrato", "note filter", "bitcrusher", "chorus", "echo"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 2.8284 },
						{
							type: "low-pass",
							cutoffHz: 13454.34,
							linearGain: 1.4142,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 2.8284 },
						{
							type: "low-pass",
							cutoffHz: 13454.34,
							linearGain: 1.4142,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					chorus: 100,
					echoSustain: 57,
					echoDelayBeats: 0.75,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 46,
					decimalOffset: 0,
					dynamism: 100,
					spread: 25,
					shape: 33,
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 0.7,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "Burden Bass",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "vibrato", "note filter", "echo", "ring mod"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.25 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.25 }],
					ringMod: 14,
					ringModHz: 76,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 1.5,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "modbox sunsoft bass",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.9,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
						},
						{
							target: "ringModulationHz",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Apathy Pluck",
				generalMidi: false,
				tags: ["harmonics", "ashiiware"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.1768 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 8 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 8 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.1768 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 8 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 8 },
					],
					effects: ["chord type", "note filter", "chorus", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.25 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.25 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 }],
					panDelay: 10,
					chorus: 86,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					harmonics: [
						100, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Fakersynth",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["transition type", "chord type", "chorus", "echo"],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "custom interval",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					panDelay: 10,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 10,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "10×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Jazzy Bells",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "chorus", "echo"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 9,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 9656.85, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 9656.85, linearGain: 0.5 }],
					panDelay: 10,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Cubed Pulsechords",
				generalMidi: false,
				tags: ["pwm", "ashiiware"],
				settings: {
					type: "PWM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "chorus", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 4756.83, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 5.6569,
						},
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 4756.83, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 5.6569,
						},
					],
					noteSubFilters8: [
						{ type: "peak", cutoffHz: 5656.85, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 0.7071,
						},
					],
					panDelay: 10,
					chorus: 100,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					pulseWidth: 35,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "decimalOffset",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Lofi Marimba",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "chorus", "echo", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 6,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 2196.8, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2196.8, linearGain: 1 }],
					panDelay: 10,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1 2←(3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
					],
				},
			},
			{
				name: "Supersaw Chords",
				generalMidi: false,
				tags: ["supersaw", "ashiiware"],
				settings: {
					type: "supersaw",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "chorus", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					panDelay: 10,
					chorus: 100,
					reverb: 61,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 50,
					shape: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Cubed FM",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					effects: ["note filter", "chorus", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 500, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 500, linearGain: 2.8284 }],
					panDelay: 0,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 84,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1←(2 3 4)",
					feedbackType: "3⟲ 4⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "1×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Synthwave Strings",
				generalMidi: false,
				tags: ["chip", "customchip", "ashiiware"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["vibrato", "granular"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					granular: 6,
					grainSize: 48,
					grainAmounts: 8,
					grainRange: 29,
					panDelay: 10,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -1,
					wave: "1/8 pulse",
					unison: "none",
					customChipWave: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 24,
						"6": 24,
						"7": 24,
						"8": 24,
						"9": 24,
						"10": 24,
						"11": 24,
						"12": 24,
						"13": 24,
						"14": 24,
						"15": 24,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 24,
						"22": 24,
						"23": 24,
						"24": 24,
						"25": 24,
						"26": 24,
						"27": 24,
						"28": 24,
						"29": 24,
						"30": 24,
						"31": 24,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "granular",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0.8,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Bellchoir",
				generalMidi: false,
				tags: ["harmonics", "ashiiware"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.25 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 1 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.25 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 1 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.0884 },
					],
					effects: ["chord type", "note filter", "chorus", "echo"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 1 }],
					panDelay: 10,
					chorus: 100,
					echoSustain: 100,
					echoDelayBeats: 0.5,
					fadeInSeconds: 0.1575,
					fadeOutTicks: -1,
					harmonics: [
						86, 0, 100, 100, 57, 0, 71, 29, 0, 14, 0, 0, 0, 0, 0, 0, 86, 43, 100, 14,
						86, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "octave",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Oceanic Lead",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware", "retro"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 6727.17,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 6727.17,
							linearGain: 0.3536,
						},
					],
					eqSubFilters1: [],
					effects: ["vibrato", "granular", "chorus", "echo"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					granular: 5,
					grainSize: 43,
					grainAmounts: 9,
					grainRange: 40,
					panDelay: 10,
					chorus: 43,
					echoSustain: 57,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "sandbox shrill pulse",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 8,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "grainSize",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Decayed Pulse",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "retro"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["note filter", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2←3←4",
					feedbackType: "1→3",
					feedbackAmplitude: 8,
					operators: [
						{ frequency: "0.12×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{
							frequency: "0.5×",
							amplitude: 15,
							waveform: "pulse width",
							pulseWidth: 8,
						},
						{ frequency: "7×", amplitude: 6, waveform: "pulse width", pulseWidth: 1 },
						{ frequency: "0.75×", amplitude: 5, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 19,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1.4,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "feedbackAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Locator Pulse",
				generalMidi: false,
				tags: ["pwm", "ashiiware", "retro"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2.8284 },
					],
					effects: ["vibrato", "chorus", "echo"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					chorus: 86,
					echoSustain: 71,
					echoDelayBeats: 1.5,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 49,
					decimalOffset: 0,
					unison: "octave",
					envelopes: [],
				},
			},
			{
				name: "Stargazer Kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "kick"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 105.11, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 74.33, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 105.11, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 74.33, linearGain: 2.8284 },
					],
					effects: ["note filter", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 1 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 1 }],
					noteSubFilters1: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 1 }],
					noteSubFilters2: [{ type: "high-pass", cutoffHz: 19027.31, linearGain: 0.125 }],
					noteSubFilters3: [],
					noteSubFilters4: [],
					panDelay: 0,
					echoSustain: 14,
					echoDelayBeats: 0.167,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "25×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Stargazer 808",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					effects: ["transition type", "distortion"],
					transition: "slide",
					clicklessTransition: false,
					distortion: 100,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "distortion",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.3,
							perEnvelopeUpperBound: 0.6,
							discrete: false,
							pitchEnvelopeStart: 12,
							pitchEnvelopeEnd: 24,
						},
					],
				},
			},
			{
				name: "Stargazer Lead",
				generalMidi: false,
				tags: ["chip", "customchip", "ashiiware", "keys"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 0.3536,
						},
					],
					effects: [
						"chord type",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "custom",
					vibratoDepth: 0.16,
					vibratoDelay: 0,
					vibratoSpeed: 5,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					chorus: 43,
					echoSustain: 57,
					echoDelayBeats: 1.5,
					reverb: 42,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": -24,
						"7": -24,
						"8": -24,
						"9": -24,
						"10": -24,
						"11": -24,
						"12": -24,
						"13": -24,
						"14": -24,
						"15": -24,
						"16": 24,
						"17": 24,
						"18": 24,
						"19": 24,
						"20": 24,
						"21": 24,
						"22": 24,
						"23": 24,
						"24": 24,
						"25": 24,
						"26": 24,
						"27": 24,
						"28": 24,
						"29": 24,
						"30": 24,
						"31": 24,
						"32": 24,
						"33": 24,
						"34": 24,
						"35": 24,
						"36": 24,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Stargazer EP",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "featured", "keys"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "vibrato", "note filter", "chorus", "echo", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "custom",
					vibratoDepth: 0.16,
					vibratoDelay: 0,
					vibratoSpeed: 5,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					panDelay: 0,
					chorus: 43,
					echoSustain: 71,
					echoDelayBeats: 1.5,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←3 2←4",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Supersaw Acid Bass",
				generalMidi: false,
				tags: ["supersaw", "ashiiware", "picked"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "peak", cutoffHz: 19027.31, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 11313.71,
							linearGain: 1.4142,
						},
						{ type: "high-pass", cutoffHz: 500, linearGain: 1 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 19027.31, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 11313.71,
							linearGain: 1.4142,
						},
						{ type: "high-pass", cutoffHz: 500, linearGain: 1 },
					],
					eqSubFilters1: [],
					effects: ["note filter", "chorus"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2.8284 }],
					panDelay: 0,
					chorus: 43,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 17,
					spread: 58,
					shape: 0,
					envelopes: [
						{
							target: "supersawSpread",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.05,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "Nightrider FM",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 707.11, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 707.11, linearGain: 0.7071 }],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3←4",
					feedbackType: "1→2",
					feedbackAmplitude: 12,
					operators: [
						{ frequency: "0.12×", amplitude: 12, waveform: "ramp", pulseWidth: 5 },
						{
							frequency: "0.12×",
							amplitude: 12,
							waveform: "pulse width",
							pulseWidth: 1,
						},
						{ frequency: "0.25×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 3, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 0.02,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 1.6,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 1.75,
							perEnvelopeLowerBound: 1.5,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "90's Synthsaw",
				generalMidi: false,
				tags: ["supersaw", "ashiiware", "retro", "keys"],
				settings: {
					type: "supersaw",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					pulseWidth: 49,
					decimalOffset: 0,
					dynamism: 67,
					spread: 67,
					shape: 67,
					envelopes: [],
				},
			},
			{
				name: "Gameboy Pad",
				generalMidi: false,
				tags: ["chip", "customchip", "ashiiware", "pad", "retro"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 }],
					effects: ["bitcrusher", "chorus", "echo", "reverb"],
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -24,
						"1": -20,
						"2": -17,
						"3": -15,
						"4": -13,
						"5": -13,
						"6": -11,
						"7": -11,
						"8": -11,
						"9": -9,
						"10": -9,
						"11": -9,
						"12": -9,
						"13": -7,
						"14": -7,
						"15": -7,
						"16": -7,
						"17": -7,
						"18": -5,
						"19": -5,
						"20": -5,
						"21": -5,
						"22": -5,
						"23": -5,
						"24": -3,
						"25": -3,
						"26": -3,
						"27": -3,
						"28": -3,
						"29": -3,
						"30": -3,
						"31": -3,
						"32": 24,
						"33": 20,
						"34": 17,
						"35": 15,
						"36": 13,
						"37": 13,
						"38": 11,
						"39": 11,
						"40": 11,
						"41": 9,
						"42": 9,
						"43": 9,
						"44": 9,
						"45": 7,
						"46": 7,
						"47": 7,
						"48": 7,
						"49": 7,
						"50": 5,
						"51": 5,
						"52": 5,
						"53": 5,
						"54": 5,
						"55": 5,
						"56": 3,
						"57": 3,
						"58": 3,
						"59": 3,
						"60": 3,
						"61": 3,
						"62": 3,
						"63": 3,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Dreamsaw",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware", "pad", "retro"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 0.7071,
						},
					],
					effects: ["transition type", "detune", "granular", "chorus", "echo"],
					transition: "interrupt",
					clicklessTransition: false,
					detuneCents: -20,
					granular: 4,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					panDelay: 0,
					chorus: 29,
					echoSustain: 29,
					echoDelayBeats: 1,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 48,
					wave: "sawtooth",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Dreamwave",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware", "pad", "retro"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 0.7071,
						},
					],
					effects: ["transition type", "detune", "granular", "chorus", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					detuneCents: -20,
					granular: 6,
					grainSize: 49,
					grainAmounts: 8,
					grainRange: 40,
					panDelay: 0,
					chorus: 43,
					echoSustain: 29,
					echoDelayBeats: 1,
					reverb: 61,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 48,
					wave: "rounded",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 64,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Dreamer Supersaw",
				generalMidi: false,
				tags: ["supersaw", "ashiiware", "retro"],
				settings: {
					type: "supersaw",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["vibrato", "bitcrusher", "echo", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 0,
					panDelay: 0,
					echoSustain: 86,
					echoDelayBeats: 1.5,
					reverb: 94,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					pulseWidth: 49,
					decimalOffset: 0,
					dynamism: 50,
					spread: 25,
					shape: 83,
					envelopes: [],
				},
			},
			{
				name: "Oneiroi FM",
				generalMidi: false,
				tags: ["fm", "fm6op", "ashiiware"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["vibrato", "note filter", "chorus", "echo"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 19027.31, linearGain: 11.3137 },
						{
							type: "low-pass",
							cutoffHz: 16000,
							linearGain: 1,
						},
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 19027.31, linearGain: 11.3137 },
						{
							type: "low-pass",
							cutoffHz: 16000,
							linearGain: 1,
						},
					],
					panDelay: 0,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3 2←4←(5 6)",
					feedbackType: "4→5",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 12, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 2, waveform: "pulse width", pulseWidth: 9 },
						{ frequency: "15×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 7, waveform: "triangle", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Dreamchimes",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "idiophone"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "granular", "bitcrusher", "echo"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 9,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 9656.85, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 9656.85, linearGain: 0.5 }],
					granular: 4,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					echoSustain: 71,
					echoDelayBeats: 1.5,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Dreamer Bass",
				generalMidi: false,
				tags: ["supersaw", "ashiiware"],
				settings: {
					type: "supersaw",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters4: [],
					effects: ["vibrato", "note filter", "distortion", "echo"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.1768,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 2 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.1768,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 2 },
					],
					noteSubFilters1: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 11313.71, linearGain: 11.3137 },
					],
					noteSubFilters2: [
						{ type: "low-pass", cutoffHz: 105.11, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 11313.71, linearGain: 11.3137 },
					],
					noteSubFilters4: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 11313.71, linearGain: 11.3137 },
					],
					distortion: 100,
					aliases: false,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 49,
					decimalOffset: 0,
					dynamism: 83,
					spread: 67,
					shape: 0,
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 1.75,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.25,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 2,
							discrete: false,
							index: 2,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Dreamer Pulse",
				generalMidi: false,
				tags: ["chip", "chipwave", "ashiiware", "retro"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"chord type",
						"vibrato",
						"distortion",
						"bitcrusher",
						"echo",
						"reverb",
						"ring mod",
					],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					ringMod: 29,
					ringModHz: 51,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 0,
					panDelay: 0,
					echoSustain: 71,
					echoDelayBeats: 1,
					reverb: 35,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 12,
					wave: "sandbox deep square",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 6,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "ringModulationHz",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Carnival Keys",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "idiophone", "keys"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"chord type",
						"note filter",
						"granular",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 9,
					noteSimplePeak: 5,
					noteFilter: [{ type: "low-pass", cutoffHz: 5890.6, linearGain: 4 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 5890.6, linearGain: 4 }],
					granular: 2,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 100,
					echoSustain: 14,
					echoDelayBeats: 1,
					reverb: 94,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Spirit Vocalsynth",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "vocal"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"vibrato",
						"note filter",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "slide in pattern",
					clicklessTransition: false,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 8,
					noteSimplePeak: 5,
					noteFilter: [{ type: "low-pass", cutoffHz: 4116.87, linearGain: 2.8284 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4116.87, linearGain: 2.8284 }],
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 100,
					reverb: 58,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "(1 2 3)←4",
					feedbackType: "1→2→3→4→1",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Spirit Xylo",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "idiophone", "keys"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["vibrato", "note filter", "chorus", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					panDelay: 10,
					chorus: 100,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1 2 3 4",
					feedbackType: "2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Liquid Sonar",
				generalMidi: false,
				tags: ["fm", "fm4op", "ashiiware", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 0.0884,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 0.0884,
						},
					],
					effects: ["vibrato", "note filter", "granular", "reverb"],
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					granular: 6,
					grainSize: 43,
					grainAmounts: 3,
					grainRange: 27,
					panDelay: 0,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←3 2←4",
					feedbackType: "2→3",
					feedbackAmplitude: 1,
					operators: [
						{ frequency: "0.5×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "12×", amplitude: 2, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "10×", amplitude: 0, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 0.8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 0.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "feedbackAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1.6,
							discrete: false,
						},
					],
				},
			},
			// { name: "", generalMidi: false, tags:["", "ashiiware"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "ashiiware"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "ashiiware"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "ashiiware"], settings: {} },
		]),
	},
	{
		name: "Jacobar475's Presets",
		presets: toNameMap([
			// -------------JukeBox 0.2.0 presets--------------
			{
				name: "Jafo wave",
				generalMidi: false,
				tags: ["chip", "customchip", "jacobar475", "retro", "keys"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 1,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"note filter",
						"granular",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 500,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 500,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.0884 },
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					granular: 0,
					grainSize: 49,
					grainAmounts: 0,
					grainRange: 40,
					distortion: 29,
					aliases: true,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 86,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: -12,
					wave: "sawtooth",
					unison: "custom",
					unisonVoices: 1,
					unisonSpread: 0.075,
					unisonOffset: 0,
					unisonExpression: 1.4,
					unisonSign: 1,
					customChipWave: {
						"0": 23,
						"1": 23,
						"2": 23,
						"3": 23,
						"4": 23,
						"5": 23,
						"6": 23,
						"7": 23,
						"8": 23,
						"9": 23,
						"10": 22,
						"11": 22,
						"12": 22,
						"13": 8,
						"14": 9,
						"15": 9,
						"16": 10,
						"17": 10,
						"18": 10,
						"19": 11,
						"20": 11,
						"21": 11,
						"22": 11,
						"23": 11,
						"24": 11,
						"25": 11,
						"26": 11,
						"27": 11,
						"28": 11,
						"29": 11,
						"30": 10,
						"31": 10,
						"32": -14,
						"33": -12,
						"34": -11,
						"35": -11,
						"36": -10,
						"37": -9,
						"38": -9,
						"39": -9,
						"40": -9,
						"41": -9,
						"42": -9,
						"43": -9,
						"44": -9,
						"45": -9,
						"46": -9,
						"47": -9,
						"48": -10,
						"49": -11,
						"50": -11,
						"51": -20,
						"52": -17,
						"53": -15,
						"54": -14,
						"55": -13,
						"56": -13,
						"57": -12,
						"58": -12,
						"59": -12,
						"60": -12,
						"61": -12,
						"62": 9,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "Crisp Hi-Hat",
				generalMidi: false,
				tags: ["noise", "jacobar475", "hihat", "retro"],
				settings: {
					type: "noise",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 4756.83, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 4756.83, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2 },
					],
					effects: ["detune", "chorus"],
					detuneCents: -20,
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "pink",
					unison: "custom",
					unisonVoices: 9,
					unisonSpread: 9,
					unisonOffset: 9,
					unisonExpression: 2,
					unisonSign: 2,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "average 470",
				generalMidi: false,
				tags: ["harmonics", "jacobar475", "picked"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 2850, linearGain: 4 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 6,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["note filter", "granular", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					granular: 3,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					panDelay: 10,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					harmonics: [
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 86, 86, 86,
						86, 86, 71, 71, 57, 43, 29, 29, 14, 0, 0, 0,
					],
					unison: "custom",
					unisonVoices: 4,
					unisonSpread: 0.042,
					unisonOffset: 0,
					unisonExpression: 0.8,
					unisonSign: 1.1,
					envelopes: [],
				},
			},
			// -------------JukeBox 0.2.1 presets--------------
			{
				name: "chiptune style U!",
				generalMidi: false,
				tags: ["chip", "customchip", "jacobar475", "picked", "pad"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.1768 }],
					eqFilterType: true,
					eqSimpleCut: 6,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["chord type"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 7,
					monoChordTone: 1,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "square",
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 0.006,
					unisonOffset: 0,
					unisonExpression: 1,
					unisonSign: 0.5,
					customChipWave: {
						"0": 14,
						"1": 14,
						"2": -3,
						"3": -3,
						"4": -3,
						"5": -4,
						"6": -4,
						"7": 15,
						"8": 15,
						"9": 15,
						"10": 16,
						"11": -2,
						"12": -6,
						"13": -9,
						"14": 19,
						"15": 20,
						"16": -4,
						"17": -5,
						"18": -4,
						"19": -4,
						"20": -4,
						"21": -4,
						"22": -4,
						"23": -3,
						"24": -2,
						"25": 1,
						"26": 24,
						"27": 24,
						"28": -7,
						"29": -24,
						"30": -24,
						"31": -24,
						"32": -24,
						"33": -24,
						"34": -24,
						"35": -24,
						"36": -24,
						"37": -24,
						"38": -20,
						"39": -18,
						"40": -16,
						"41": -14,
						"42": -10,
						"43": -11,
						"44": -21,
						"45": -19,
						"46": -18,
						"47": -18,
						"48": -11,
						"49": -13,
						"50": -11,
						"51": -10,
						"52": -9,
						"53": -16,
						"54": -14,
						"55": -13,
						"56": -12,
						"57": -11,
						"58": 0,
						"59": -12,
						"60": -23,
						"61": -23,
						"62": -22,
						"63": -15,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "hallucination harmonic",
				generalMidi: false,
				tags: ["harmonics", "jacobar475", "bellows", "pad"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "peak", cutoffHz: 13454.34, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 500, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 13454.34, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 500, linearGain: 11.3137 },
					],
					eqSubFilters1: [],
					effects: ["chord type", "granular", "chorus", "reverb"],
					chord: "custom interval",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					granular: 4,
					grainSize: 9,
					grainAmounts: 10,
					grainRange: 40,
					panDelay: 0,
					chorus: 100,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 43, 100, 100, 100, 100,
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
					],
					unison: "hum",
					envelopes: [],
				},
			},
			// -------------JukeBox 0.2.2 presets--------------
			{
				name: "dark lead",
				generalMidi: false,
				tags: ["harmonics", "jacobar475", "string"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "high-pass", cutoffHz: 125, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 1,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 125, linearGain: 0.25 }],
					effects: ["chorus", "echo", "reverb"],
					panDelay: 10,
					chorus: 100,
					echoSustain: 71,
					echoDelayBeats: 0.75,
					reverb: 100,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 100, 100, 100, 100, 100, 71, 57, 29, 14, 14, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "hum",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// -------------JukeBox 0.2.3 presets--------------
			{
				name: "tape slider",
				generalMidi: false,
				tags: ["fm", "fm4op", "jacobar475", "pad", "picked"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
					],
					effects: [
						"transition type",
						"detune",
						"vibrato",
						"note filter",
						"chorus",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					detuneCents: -4,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 3222.02, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 3222.02, linearGain: 1 }],
					panDelay: 10,
					chorus: 0,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 13,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "BASS BOOST!",
				generalMidi: false,
				tags: ["fm", "fm4op", "jacobar475", "retro", "distortion"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 420.45, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 297.3,
							linearGain: 5.6569,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 420.45, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 297.3,
							linearGain: 5.6569,
						},
					],
					effects: ["bitcrusher", "chorus"],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "2×", amplitude: 12, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 3, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			// -------------JukeBox 0.2.3 presets--------------
			{
				name: "Bootleg Honky Tonk",
				generalMidi: false,
				tags: ["chip", "chipwave", "jacobar475", "string"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "chorus", "reverb"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 7,
					monoChordTone: 1,
					panDelay: 0,
					chorus: 86,
					reverb: 48,
					fadeInSeconds: 0.0938,
					fadeOutTicks: 12,
					wave: "1/8 pulse",
					unison: "hum",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 8,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "chorus",
							envelope: "swell",
							inverse: true,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0.9,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
						},
					],
				},
			},
			// -------------JukeBox 0.2.4 presets--------------
			{
				name: "Lightlylit lead",
				generalMidi: false,
				tags: ["fm", "fm6op", "jacobar475", "picked", "pad"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 9,
					eqSubFilters0: [],
					effects: ["note filter", "distortion", "chorus", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 }],
					distortion: 29,
					aliases: false,
					panDelay: 10,
					chorus: 57,
					echoSustain: 14,
					echoDelayBeats: 0.25,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "PurpleTopped bass",
				generalMidi: false,
				tags: ["chip", "customchip", "jacobar475", "bellows"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 }],
					effects: ["vibrato"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "square",
					unison: "honky tonk",
					customChipWave: {
						"0": 24,
						"1": 19,
						"2": 1,
						"3": 1,
						"4": 1,
						"5": 1,
						"6": 1,
						"7": 1,
						"8": 1,
						"9": 1,
						"10": -13,
						"11": -16,
						"12": -16,
						"13": -16,
						"14": -16,
						"15": -17,
						"16": -16,
						"17": -16,
						"18": -16,
						"19": -16,
						"20": -16,
						"21": -9,
						"22": -8,
						"23": -6,
						"24": -6,
						"25": 0,
						"26": 0,
						"27": 1,
						"28": 1,
						"29": 1,
						"30": 1,
						"31": 1,
						"32": 0,
						"33": 18,
						"34": 18,
						"35": 18,
						"36": 18,
						"37": 18,
						"38": -15,
						"39": -18,
						"40": -19,
						"41": -19,
						"42": -19,
						"43": -19,
						"44": -19,
						"45": -19,
						"46": -20,
						"47": 3,
						"48": 0,
						"49": -1,
						"50": -2,
						"51": -2,
						"52": -2,
						"53": -2,
						"54": -2,
						"55": -2,
						"56": -2,
						"57": 0,
						"58": 0,
						"59": -3,
						"60": -1,
						"61": 0,
						"62": 0,
						"63": -1,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteVolume",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 15,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// -------------JukeBox 0.3.0 presets--------------
			{
				name: "Granular Arp",
				generalMidi: false,
				tags: ["chip", "chipwave", "jacobar475", "picked", "retro", "distortion"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"chord type",
						"vibrato",
						"note filter",
						"granular",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 4,
					monoChordTone: 1,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.0884 }],
					granular: 1,
					grainSize: 3,
					grainAmounts: 10,
					grainRange: 2,
					distortion: 29,
					aliases: true,
					bitcrusherOctave: 2,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 0.083,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					wave: "todbox beta banana wave",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 35,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Pulse-X",
				generalMidi: false,
				tags: ["chip", "customchip", "jacobar475", "picked", "retro"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "note filter"],
					transition: "slide",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "square",
					unison: "honky tonk",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": -24,
						"7": -24,
						"8": -24,
						"9": -24,
						"10": -24,
						"11": -24,
						"12": -24,
						"13": -24,
						"14": -24,
						"15": -24,
						"16": -24,
						"17": -24,
						"18": 24,
						"19": 24,
						"20": 24,
						"21": 24,
						"22": 24,
						"23": 24,
						"24": 24,
						"25": 24,
						"26": 24,
						"27": 24,
						"28": 24,
						"29": 24,
						"30": 24,
						"31": 10,
						"32": 10,
						"33": 10,
						"34": 10,
						"35": 10,
						"36": 10,
						"37": 10,
						"38": 10,
						"39": 10,
						"40": -4,
						"41": -4,
						"42": -4,
						"43": -3,
						"44": -3,
						"45": -23,
						"46": -24,
						"47": -24,
						"48": -24,
						"49": -24,
						"50": -23,
						"51": -23,
						"52": -23,
						"53": -24,
						"54": -24,
						"55": -24,
						"56": -24,
						"57": -24,
						"58": -24,
						"59": -23,
						"60": -21,
						"61": -21,
						"62": -20,
						"63": -18,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Pulse-Y",
				generalMidi: false,
				tags: ["chip", "customchip", "jacobar475", "bellows", "retro", "keys", "pad"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "note filter"],
					transition: "slide",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "square",
					unison: "honky tonk",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": -24,
						"7": -24,
						"8": -24,
						"9": -24,
						"10": -24,
						"11": -24,
						"12": -24,
						"13": -24,
						"14": -24,
						"15": -24,
						"16": -7,
						"17": -7,
						"18": -7,
						"19": -7,
						"20": -7,
						"21": -7,
						"22": -7,
						"23": -7,
						"24": -6,
						"25": -6,
						"26": -6,
						"27": -6,
						"28": 24,
						"29": 24,
						"30": 24,
						"31": 10,
						"32": 10,
						"33": 10,
						"34": 10,
						"35": -19,
						"36": -19,
						"37": -18,
						"38": -18,
						"39": -18,
						"40": -17,
						"41": -17,
						"42": -17,
						"43": -17,
						"44": -3,
						"45": -23,
						"46": -24,
						"47": -24,
						"48": -24,
						"49": -24,
						"50": 4,
						"51": 4,
						"52": 4,
						"53": 5,
						"54": 5,
						"55": 6,
						"56": 6,
						"57": 6,
						"58": 7,
						"59": 7,
						"60": 8,
						"61": 8,
						"62": -20,
						"63": -18,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			// { name: "", generalMidi: false, tags:["", "jacobar475"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "jacobar475"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "jacobar475"], settings: {} },
		]),
	},
];
